import React, { useEffect } from 'react';
// import heroBackgroundImg1 from '../assets/images/stock-images/joshua-coleman-Mbn9oZkQ3ow-unsplash.jpg';
import CardSection from '../components/Main/CardSection.js';
import HeroSection from '../components/Main/Hero.js';
import Analytics from '../utils/Analytics.js';
import CardImg2 from './../assets/images/stock-images/2.jpg';
import CardImg3 from './../assets/images/stock-images/2.jpg';
import About from '../components/Main/About.js';
import Contact from '../components/Main/Contact.js';
import Testimonials from '../components/Main/Testimonials.js';
import GoogleMaps from '../components/Main/GoogleMaps.js';
import Section from '../components/Global/Section.js';
import CoreValues from '../components/Main/CoreValues.js';

export default function LandingPage() {
	const cardData = [];

	useEffect(() => {
		Analytics.pageViewEvent('LandingPage', {
			sessionId: '',
		});
	}, []);
	return (
		<div>
			<HeroSection />
			<About />

			{/* <CardSection cards={cardData} /> */}
			<Testimonials />
			<Contact />
		</div>
	);
}
